import callRequestBase from '../../call-request-base/call-request-base';
import callRequestLahiForm from './call-request-lahi-form/call-request-lahi-form.vue';
import {mapState, mapActions} from 'vuex';
export default {
	extends: callRequestBase,
	components: {
		callRequestLahiForm
	},
	props: {
		requestZipCode: {
			type: Boolean,
			default: false
		},
		sendData: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapState(['lahiSessionId'])
	},
	methods: {
		...mapActions(['setLahiSessionId'])
	}
};
